import { gql } from '@grandvisionhq/graphql';
import { recoverInactiveCartResult } from '../fragments/recover-inactive-cart-result.js';

const RECOVER_INACTIVE_CART = gql`
  mutation RecoverInactiveCart($cartParams: OrderedCheckoutInput!) {
    recreateOrderedCheckout(input: $cartParams) {
      ...RecoverInactiveCartFragment
    }
  }
  ${recoverInactiveCartResult}
`;

export { RECOVER_INACTIVE_CART };
//# sourceMappingURL=recover-inactive-cart.js.map
